import React from 'react'
import { Goods, IPricingMethod } from '@/model/types/goods'
import { Row, Expaned } from '@/components/layout/layout'
import { transfromNumberToHanzi } from '@/utils'
import Iconfont from '@/components/iconfont/iconfont'
import './pirces-box.scss'
import { getBEMCls } from '@/utils/classname'

interface Iprops {
    pricing_methods: IPricingMethod[]
    goods: Goods
}
export const PricesBox: React.FC<Iprops> = ({ pricing_methods, goods }) => {
    const cls = (...args: string[]) => getBEMCls('pricesBox', ...args)

    return (
        <div className={cls('goods-info', 'price-box')}>
            {pricing_methods.map((item, index: number) => {
                return (
                    <Row
                        className={cls(
                            'goods-info',
                            pricing_methods.length !== index + 1 ? 'price-wrapper' : 'price-wrapper-no',
                        )}
                        data-padding-v-7
                        key={item.id}
                    >
                        <div data-font-size-14 data-color-000 data-font-weight-600 data-margin-right-10>
                            售价{transfromNumberToHanzi(index + 1)}
                        </div>
                        <Row data-font-size-14>
                            <div data-color-000>
                                {item.sale_prices.map(val => (
                                    <div key={val.id}>
                                        购买量{'>='}
                                        {val.threshold}；
                                        <span className={cls('goods-info', 'price')}>
                                            {val.sale_price}元/{val.sale_unit.name}
                                        </span>
                                    </div>
                                ))}
                            </div>
                            {item.member_price.sale_price > 0 && (
                                <div className={cls('goods-info', 'memberPrice')}>
                                    <Iconfont name="icon8huiyuanjia-12"></Iconfont>
                                    <span data-margin-left-5>
                                        {item.member_price.sale_price}元/
                                        {item.member_price.sale_unit.name}
                                    </span>
                                </div>
                            )}
                        </Row>
                        <Expaned
                            data-justify-content-flex-end
                            data-row
                            style={{
                                fontSize: item.sales_unit_ratio > 1 && item.price_annotation ? '12px' : '14px',
                            }}
                        >
                            {item.sales_unit_ratio > 1 && (
                                // tslint:disable-next-line:max-line-length
                                <div className={cls('goods-info', 'text-state')}>
                                    一{goods.stock_unit.name}={item.sales_unit_ratio}
                                    {item.sales_unit.name}
                                </div>
                            )}
                            {item.price_annotation && (
                                <div className={cls('goods-info', 'text-state')} data-margin-left-16>
                                    {item.price_annotation}
                                </div>
                            )}
                        </Expaned>
                    </Row>
                )
            })}
        </div>
    )
}
